import React from "react";
import useFullPageTitle from "../hooks/use-full-page-title";

function DocumentTitle() {

    const title = useFullPageTitle();

    function setDocumentTitle() {
        if (typeof document.title !== 'undefined') {
            document.title = title;
        }
    }

    React.useEffect(() => {
        setDocumentTitle();
    }, []);

    React.useEffect(() => {
        setDocumentTitle();
    }, [title]);

    return null;
}

export default DocumentTitle;
